export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0028.9846fe02.webp";